var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6002 21.3752L6.8252 12.6002C6.74186 12.5002 6.67936 12.4044 6.6377 12.3127C6.59603 12.221 6.5752 12.1169 6.5752 12.0002C6.5752 11.8835 6.59603 11.7794 6.6377 11.6877C6.67936 11.596 6.74186 11.5002 6.8252 11.4002L15.6002 2.6252C15.8169 2.4252 16.0794 2.3252 16.3877 2.3252C16.696 2.3252 16.9502 2.4252 17.1502 2.6252C17.3669 2.84186 17.4752 3.10436 17.4752 3.4127C17.4752 3.72103 17.3669 3.98353 17.1502 4.20019L9.3502 12.0002L17.1502 19.8002C17.3835 20.0335 17.496 20.3002 17.4877 20.6002C17.4794 20.9002 17.3669 21.1502 17.1502 21.3502C16.9335 21.5669 16.6752 21.6752 16.3752 21.6752C16.0752 21.6752 15.8169 21.5752 15.6002 21.3752Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fdedd03b2864c3708d50a73a6bc97b13.svg";
export { ForwardRef as ReactComponent };